import { createBlock } from 'factories/block';
import { createEditableBtn } from './editableBtn';

export const createModalWithEditableBtn = ({ ...props }) => {
  return createBlock('Modal', [createEditableBtn({})], {
    props: { type: 'ModalWithEditableBtn' },
    meta: {
      subType: 'ModalWithEditableBtn',
    },
  });
};
